module.exports = __webpack_public_path__ + "b2afa6d547824d7f7c205116b85b17b5.png";